<button mat-icon-button class="close-button" [mat-dialog-close]="false">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
        <form [formGroup]="enderecoForm" (ngSubmit)="submit()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskCep" matInput name="telefone1" [formControl]="enderecoForm.controls['cep']"
                  placeholder="CEP" (blur)="consultaCep($event.target.value)">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
           
              <mat-form-field class="full-width">
                <mat-label>Cidade</mat-label>
                <mat-select [formControl]="enderecoForm?.controls['cadMun']!" (selectionChange)="onSelectionChange($event)">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="enderecoForm?.controls['searchCidade']!" placeholderLabel="Pesquisar Cidade.."
                      noEntriesFoundLabel="Cidade não encontrada" [searching]="searching">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let cadMun of cidades" [value]="cadMun">
                    <span>{{ cadMun?.municipio?.trim() }} - </span>
                    <span> {{cadMun?.uf?.trim()}}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
  

            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput type="text" name="endereco"
                  [formControl]="enderecoForm.controls['endereco']" placeholder="Endereço">
              </mat-form-field>
              <small *ngIf="enderecoForm.controls['endereco'].hasError('required') && enderecoForm.controls['endereco'].touched"
                class="form-error-msg"> Endereço é obrigatório </small>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskUpper" matInput type="text" name="numero"
                  [formControl]="enderecoForm.controls['numero']" placeholder="Número">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskUpper" matInput name="bairro" [formControl]="enderecoForm.controls['bairro']"
                  placeholder="Bairro">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskUpper" matInput name="complemento"
                  [formControl]="enderecoForm.controls['complemento']" placeholder="Complemento">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input matInput [imask]="maskEmail" type="email" name="email" [formControl]="enderecoForm.controls['email']"
                  placeholder="Email">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskFone" matInput name="celular" [formControl]="enderecoForm.controls['celular']"
                  placeholder="Celular">
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskFone" matInput name="telefone1" [formControl]="enderecoForm.controls['telefone1']"
                  placeholder="Telefone Fixo">
              </mat-form-field>
            </div>

            <div fxFlex="100" class="pr-1">
              <div fxLayout="row wrap" fxLayoutGap="16px" class="classificacao-endereco-wrap">
                <mat-checkbox [formControl]="enderecoForm.controls['entrega']">Endereço de Entrega</mat-checkbox>
                <mat-checkbox [formControl]="enderecoForm.controls['cobranca']">Endereço de Cobrança</mat-checkbox>
                <mat-checkbox [formControl]="enderecoForm.controls['padrao']">Endereço Padrão</mat-checkbox>
              </div>
            </div>
          </div>
        </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
      <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
      [disabled]="enderecoForm.invalid" (click)="this.save();$event.preventDefault();"><mat-icon>save</mat-icon>{{"SAVE" |
          translate }}
      </button>
      <span fxFlex></span>
      <button mat-button color="warn" type="button" (click)="dialogRef.close(false)"><mat-icon>close</mat-icon>{{"CLOSE" | translate }}</button>
  </div>
</mat-dialog-actions>


